// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export var TimeUnit_Enum;
(function (TimeUnit_Enum) {
    TimeUnit_Enum["DAYS"] = "DAYS";
    TimeUnit_Enum["WEEKS"] = "WEEKS";
    TimeUnit_Enum["MONTHS"] = "MONTHS";
})(TimeUnit_Enum || (TimeUnit_Enum = {}));
export var TimeUnit_Enum_index;
(function (TimeUnit_Enum_index) {
    TimeUnit_Enum_index[TimeUnit_Enum_index["DAYS"] = 0] = "DAYS";
    TimeUnit_Enum_index[TimeUnit_Enum_index["WEEKS"] = 1] = "WEEKS";
    TimeUnit_Enum_index[TimeUnit_Enum_index["MONTHS"] = 2] = "MONTHS";
})(TimeUnit_Enum_index || (TimeUnit_Enum_index = {}));
export const ScheduledService = {
    /**
     * ScheduleMessageBatch allows user to scheduled multiple messages at once (up to 100)
     * Limitations:
     *   - source_system_enum is same for all messages
     */
    ScheduleMessageBatch(fn, req) {
        return fn(`/messaging/scheduled/v1/messages:scheduleBatch`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * ListMessages provides dynamic querying of scheduled messages
     */
    ListMessages(fn, req) {
        return fn(`/messaging/scheduled/v1/messages?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    ChartMessages(fn, req) {
        return fn(`/messaging/scheduled/v1/chart-messages?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
};
